<template>
  <v-card>
    <v-toolbar flat dense>
      <!-- <v-toolbar-title>Totem</v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Cerca un prodotto"
        hide-details
        clearable
        clear-icon="mdi-close-circle-outline"
        class="mt-3"
      ></v-text-field>
      <v-btn
        class="ml-5"
        color="success"
        :disabled="!daSalvare"
        @click.stop="onSalvaModifiche"
        >Salva modifiche</v-btn
      >
    </v-toolbar>
    <v-row no-gutters>
      <v-col cols="3">
        <v-card-title>
          <v-btn
            small
            title="Crea un elemento di primo livello"
            @click="creaElementoRoot"
            >Crea categoria</v-btn
          >
          <v-btn
            small
            icon
            class="ml-3"
            :title="expanded ? 'Collassa tutti i nodi' : 'Espandi tutti i nodi'"
            @click="toggleTreeview"
          >
            <v-icon>{{
              expanded ? "mdi-arrow-collapse-all" : "mdi-arrow-expand-all"
            }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-treeview
            :items="items"
            :search="search"
            :open.sync="open"
            dense
            hoverable
            :open-on-click="true"
            :return-object="true"
            transition
            @update:active="onItemSelected"
            @update:open="onUpdateOpen"
            ref="totemTree"
          >
            <template v-slot:label="{ item }">
              <div @click="onRowSelected(item)">{{ item.name }}</div>
            </template>
            <template v-slot:append="{ item }">
              <v-btn
                v-if="!item.children || item.children.length === 0"
                icon
                @click.stop="deleteItem(item)"
                title="Cancella l'elemento"
                ><v-icon small>mdi-delete</v-icon></v-btn
              >
              <v-btn
                v-if="!item.isProdotto"
                icon
                @click.stop="onNewItem(item)"
                title="Aggiungi una sottocategoria"
                ><v-icon small>mdi-tab-plus</v-icon></v-btn
              >
              <v-btn
                v-if="!item.isProdotto"
                icon
                @click.stop="onNewItem(item, true)"
                title="Aggiungi prodotto"
                ><v-icon small>mdi-plus-circle-outline</v-icon></v-btn
              >
            </template>
          </v-treeview>
        </v-card-text>
      </v-col>
      <v-col v-if="!blocco">
        <v-banner :sticky="true" style="top:30px;">
          <v-card class="d-flex align-center mb-6" flat height="200" tile>
            <div class="pa-2 text-h5">Scegli la voce da modificare</div>
          </v-card>
        </v-banner>
      </v-col>
      <v-col v-else>
        <v-banner :sticky="true" style="top:30px;">
          <v-card-title class="mt-5">{{ tipoBlocco(blocco) }}</v-card-title>
          <v-card-subtitle>{{ blocco.name }}</v-card-subtitle>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-row v-if="!blocco.isProdotto">
                  <v-col cols="12"
                    ><v-text-field
                      v-model="blocco.name"
                      label="nome"
                      hide-details
                      clearable
                      outlined
                      dense
                      @input="modificatoName(blocco)"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12"
                    ><v-text-field
                      v-model="blocco.codice"
                      label="codice"
                      :disabled="!blocco.__nuovo"
                      hide-details
                      clearable
                      outlined
                      dense
                      @change="modificato"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12"
                    ><v-text-field
                      v-model="blocco.descrizione"
                      label="descrizione"
                      hide-details
                      clearable
                      outlined
                      dense
                      @change="modificato"
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12">
                    <p-prodotto
                      :item="itemCodice(blocco)"
                      :index="0"
                      @change="componentValueChange"
                      :updateTrigger="updateTrigger"
                      :solo="false"
                      :suTable="false"
                      :isLotto="false"
                      :isBom="false"
                      :isProdottoBase="false"
                      :clearInfo="clearInfo"
                      :popolaInfo="popolaInfo"
                    />
                  </v-col>
                  <v-col cols="12"
                    ><v-text-field
                      v-model="blocco.descrizione"
                      label="descrizione"
                      hide-details
                      clearable
                      outlined
                      dense
                      @change="modificato"
                    ></v-text-field
                  ></v-col>
                </v-row>
                <v-row v-if="blocco.livello === 0">
                  <v-col cols="6"
                    ><v-switch
                      v-model="blocco.attivo"
                      inset
                      dense
                      label="categoria attiva"
                      class="ml-5 mt-0"
                      @change="modificato"
                  /></v-col>
                </v-row>
                <v-row v-else-if="blocco.isProdotto">
                  <v-col cols="6"
                    ><v-text-field
                      v-model="blocco.prezzo"
                      label="prezzo"
                      hide-details="auto"
                      :prefix="triggerPrezzo && blocco.prezzo ? '€' : ''"
                      :suffix="
                        mostraDeltaListino
                          ? 'L1: ' + blocco.prezzoListino + ' €'
                          : ''
                      "
                      class="mb-4"
                      outlined
                      dense
                      :rules="[numerico]"
                      @change="modificato"
                    ></v-text-field>
                    <v-text-field
                      v-model="blocco.deltaPrezzo"
                      label="delta prezzo"
                      hide-details="auto"
                      :prefix="triggerPrezzo && blocco.prezzo ? '€' : ''"
                      outlined
                      dense
                      :rules="[numerico]"
                      @change="modificato"
                    />
                  </v-col>
                  <v-col cols="6"
                    ><v-switch
                      v-model="blocco.attivo"
                      inset
                      dense
                      label="Prodotto attivo"
                      class="ml-5 mt-0"
                      @change="modificato"
                  /></v-col>
                  <v-col cols="6"
                    ><v-switch
                      v-model="blocco.esaurito"
                      inset
                      dense
                      label="Mostra come esaurito"
                      class="ml-5 mt-0"
                      @change="modificato"
                  /></v-col>
                  <v-col cols="6"
                    ><v-switch
                      v-model="blocco.upselling"
                      inset
                      dense
                      label="Mostra per upselling"
                      class="ml-5 mt-0"
                      @change="modificato"
                  /></v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="6"
                    ><v-switch
                      v-model="blocco.attivo"
                      inset
                      dense
                      label="gruppo attivo"
                      class="ml-5 mt-0"
                      @change="modificato"
                  /></v-col>
                </v-row>
                <v-row v-if="!blocco.isProdotto">
                  <v-col cols="6">
                    <v-text-field
                      v-if="blocco.ricorsivo == false"
                      v-model="blocco.deltaPrezzo"
                      label="delta prezzo"
                      hide-details="auto"
                      :prefix="triggerPrezzo && blocco.prezzo ? '€' : ''"
                      outlined
                      dense
                      :rules="[numerico]"
                      @change="modificato"
                    />
                    <v-switch
                      v-model="blocco.ricorsivo"
                      inset
                      dense
                      label="Menu | Categoria"
                      class="ml-5 mt-0"
                      @change="modificato"
                    />
                    <v-switch
                      v-model="blocco.mostraDeltaPrezzo"
                      inset
                      dense
                      label="Mostra prezzo aggiunta"
                      class="ml-5 mt-0"
                      @change="modificato"
                    />
                  </v-col>
                  <v-col cols="6"
                    ><v-switch
                      v-model="blocco.raggruppato"
                      inset
                      dense
                      label="Raggruppato"
                      class="ml-5 mt-0"
                      @change="modificato"
                  /></v-col>
                </v-row>
                <v-row v-if="blocco.livello === 1">
                  <v-col cols="8">
                    <v-select
                      v-model="blocco.stampa"
                      :items="stampantiComande"
                      outlined
                      dense
                      label="Stampanti"
                      multiple
                      hint="Destinazione stampa comande"
                      persistent-hint
                      item-text="descrizione"
                      item-value="codice"
                      @change="onChangeStampa"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-img :src="blocco.immagine" width="100%" class="pb-7"></v-img>
              </v-col>
            </v-row>
          </v-card-text>
        </v-banner>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
/*  eslint-disable */
import { sanitize } from "@/components/helpers";
import * as dot from "dot-object";
import { v4 as uuidv4 } from "uuid";
// import { verificaLicenza } from '@/mixins/verificaLicenza.js'
import prodotti from "@/services/prodottiService";
// import configurazioni from '@/services/configurazioniService'
import pProdotto from "@/views/distintaBase/components/dettaglioDistinta/elementi/prodotto";

export default {
  components: {
    pProdotto,
  },
  props: {
    item: Object,
    refresh: Number,
  },
  // mixins: [ verificaLicenza ],
  data() {
    return {
      tabs: null,
      // sezione: null,
      expanded: true,
      updateTrigger: 1,
      search: null,
      caseSensitive: false,
      open: [],
      itemsScroller: [],
      // TODO: La versione definitiva dovrebbe essere come le impostazioni di VSCode --> selezionando treeview
      //        porta sulla voce corretta ma si può scrollare anche sulle voci precedenti
      //        La versione attuale di virtual-scroller non permette di spostarsi da codice --> non si riesce a puntare dove visualizzare
      //        Workaround: Alla selezione su treeview cambia l'elenco degli items visualizzabili
      blocco: null,
      struttura: null,
      daSalvare: false,
      defaultRootItem: {
        id: "",
        codice: "",
        name: "",
        descrizione: "",
        isProdotto: false,
        raggruppato: false,
        livello: 0,
        attivo: true,
        stampa: [],
        children: [],
      },
      numerico: (value) =>
        !value || !isNaN(value) || "Il valore deve essere numerico",
      defaultTotem: null,
      clearInfo: 1,
      popolaInfo: 1,
      elencoProdotti: [],
      elencoIds: [],
      triggerPrezzo: 1,
      stampantiComande: [],
    };
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },
  beforeRouteLeave(to, from, next) {
    if (this.modificheNonSalvate) {
      const answer = window.confirm(
        "Ci sono delle modifiche non salvate, confermi uscita ?"
      );
      if (!answer) return false;
    }
    next();
  },
  watch: {
    async refresh() {
      await this.impostaInfo();
    },
  },
  async mounted() {
    // await this.gestioneToken()
    await this.impostaInfo();
  },
  computed: {
    items() {
      return this.struttura || [];
    },
    modificheNonSalvate() {
      return this.daSalvare;
    },
    mostraDeltaListino() {
      return (
        this.blocco &&
        parseFloat(this.blocco.prezzo) !== parseFloat(this.blocco.prezzoListino)
      );
    },
  },
  methods: {
    changeBlock(block, prop, newValue) {
      block[prop] = newValue;
      this.modificato();
    },
    async impostaInfo() {
      // const impostazioni = await configurazioni.getConfigurazione('totem')
      const info = this.item;
      this.defaultTotem = info.defaultTotem;

      // Verificare se associare le categorie alle stampanti o le stampanti alle categorie
      this.stampantiComande = info.stampantiComande;
      const categorieTotem = info.struttura;
      this.struttura = categorieTotem || [];

      this.fixRecurse(this.struttura);
      if (this.elencoIds.length > 0) {
        this.elencoProdotti = await prodotti.getProdottiByIds(this.elencoIds);
      }
      this.struttura = _.sortBy(this.struttura, "ordine");
    },
    toggleTreeview() {
      this.expanded = !this.expanded;
      this.$refs.totemTree.updateAll(this.expanded);
    },
    tipoBlocco(blocco) {
      if (blocco.isProdotto) return "Prodotto";
      if (blocco.ricorsivo) return "Categoria";
      return "Gruppo";
      // switch (blocco.livello) {
      //   case 0:
      //     return "Categoria";
      //   case 1:
      //     return "Gruppo";
      //   case 2:
      //     return "Prodotto";
      //   default:
      //     return "";
      // }
    },
    creaElementoRoot() {
      let el = JSON.parse(JSON.stringify(this.defaultRootItem));
      el.name = `Nuova categoria ${this.struttura.length + 1}`;
      el.codice = sanitize(el.name, true);
      el.id = uuidv4();
      el.__nuovo = true;
      this.struttura.push(el);
      this.daSalvare = true;
      const item = this.struttura.find((x) => x.id === el.id);
      this.onRowSelected(item);
    },
    modificato() {
      this.daSalvare = true;
      this.triggerPrezzo++;
    },
    modificatoPrezzo() {
      // this.blocco.prezzo = this.blocco.prezzo && parseFloat(this.blocco.prezzo);
      // this.daSalvare = true;
      // this.triggerPrezzo++;
    },
    modificatoName(item) {
      if (item.livello < 2) {
        item.codice = sanitize(item.name, true);
      }
      this.daSalvare = true;
    },
    pushIfNotExists(item) {
      if (!this.elencoIds.includes(item)) {
        this.elencoIds.push(item);
      }
    },
    fixRecurse(items, parentId) {
      // inserisce parentId se non esiste
      for (let el of items) {
        if (el.livello === 2) {
          this.pushIfNotExists(el.codice);
        } else {
          // el.ricorsivo = true;
        }
        if (!el.parentId) {
          el.parentId = parentId;
        }
        if (el.children) {
          this.fixRecurse(el.children, el.id);
        }
      }
    },
    findRecurse(items, id) {
      var item;
      for (let el of items) {
        if (el.id === id) {
          item = el;
        } else {
          if (el.children) {
            item = this.findRecurse(el.children, id);
          }
        }
        if (item) {
          break;
        }
      }
      return item;
    },
    deleteItem(item) {
      const answer = window.confirm("Confermi cancellazione elemento ?");
      if (!answer) return false;
      if (!item.parentId) {
        let elx = this.struttura.findIndex((x) => x.id === item.id);
        if (elx !== -1) {
          this.struttura.splice(elx, 1);
        }
      } else {
        let parent = this.findRecurse(this.struttura, item.parentId);
        let elx = parent.children.findIndex((x) => x.id === item.id);
        parent.children.splice(elx, 1);
      }
      this.daSalvare = true;
    },
    onChangeStampa() {
      this.daSalvare = true;
    },
    onNewItem(item, isProdotto) {
      let el = JSON.parse(JSON.stringify(this.defaultRootItem));
      el.name = `Nuovo Elemento ${item.children.length + 1}`; // TODO: Prendere il valore dell'ultimo, altrimenti errore se cancello un elemento e ricreo
      el.id = uuidv4();
      el.parentId = item.id;
      el.livello = isProdotto ? 2 : item.livello + 1;
      el.isProdotto = isProdotto;
      item.children.push(el);
      this.daSalvare = true;
      const newItem = item.children.find((x) => x.id === el.id);

      this.open.push(item);
      this.onUpdateOpen(this.open);
      this.onRowSelected(newItem);
    },
    preventNav(event) {
      if (!this.modificheNonSalvate) return;
      event.preventDefault();
      event.returnValue = "";
    },
    async onSalvaModifiche() {
      this.$emit("aggiorna", this.item, this.struttura);
      /*         let totem = await configurazioni.getConfigurazione('totem')
        totem.struttura = this.struttura
        await configurazioni.modificaConfigurazione(totem) */
      this.daSalvare = false;
    },
    async onItemSelected(elementi) {
      let el = elementi && elementi.length > 0 ? elementi[0] : {};
      if (!_.isEmpty(el)) {
        this.onRowSelected(el);
      }
    },
    onUpdateOpen(elementi) {
      this.expanded = elementi.length > 0;
    },
    onRowSelected(item) {
      if (item) {
        this.tabs = 0;
        this.blocco = item;
      } else {
        this.blocco = null;
      }
      this.clearInfo++;
      this.popolaInfo++;
    },
    itemCodice(item) {
      return {
        model: "codice",
        valueField: "codice",
        label: "Codice Prodotto",
        type: "Prodotto",
        required: false,
        hint: "descrizione",
        readOnly: true,
        addForbidden: true,
        value: (item && item.codice) || "",
      };
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals, item } = data;
      let tgt = {};
      if (subModel) {
        let vv = value[subModel];
        if (decimals >= 0) {
          s;
          vv = +parseFloat(vv).toFixed(decimals);
        }
        dot.str(model, vv, tgt);
      } else {
        let vv = value;
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals);
        }
        dot.str(model, vv, tgt);
      }

      _.merge(this.blocco, tgt);
      this.daSalvare = true; // TODO: solo nel caso di modifiche reali
      await this.aggiornaCorrelati(data);
    },
    async aggiornaCorrelati(data) {
      switch (data.model) {
        case "codice":
          if (
            data.value !== undefined &&
            data.item.descrizione !== this.blocco.descrizione
          ) {
            // if (data.value !== undefined) {
            this.blocco.descrizione = _.get(data, "item.descrizione", "");
            this.blocco.codice = _.get(data, "item.codice", "");
            this.blocco.name = _.get(data, "item.descrizione", "");
            this.blocco.unitaMisura = _.get(
              data,
              "item.item.magazzino.unitaMisura",
              ""
            );
            this.blocco.presenzaVariazioni = _.get(
              data,
              "item.item.presenzaVariazioni",
              false
            );
            this.blocco.prezzo = _.get(data, "item.item.prezzo.L1.base", "");
            this.blocco.prezzoListino = this.blocco.prezzo;
            const allegati = _.get(data, "item.item.allegati");
            const allegato = allegati
              ? allegati.find(
                  (x) => x.description && x.description.codice === "totem"
                )
              : null;
            this.blocco.immagine = allegato ? allegato.pathFile : "";
            this.updateTrigger++;
            this.triggerPrezzo++;
          } else {
            this.daSalvare = false;
            this.updateTrigger++;
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-component {
  position: -webkit-sticky;
  position: sticky;
  top: 20px;
}
</style>
